import { Icons, CommunityTypes } from 'types';
import energyDemandCoverImg from 'resources/images/bg/project-type/Energy_demand_bg.jpg';
import forestryCoverImg from 'resources/images/bg/project-type/Foresty_bg.jpg';
import energyDistributionCoverImg from 'resources/images/bg/project-type/EnergyDistribution_bg.jpg';
import energyIndustriesCoverImg from 'resources/images/bg/project-type/EnergyIndustries_bg.jpg';
import chemicalIndustryCoverImg from 'resources/images/bg/project-type/ChemicalIndustry_bg.jpg';
import fugitiveEmissionsCoverImg from 'resources/images/bg/project-type/FugitiveEmissions_bg.jpg';
import livestockCoverImg from 'resources/images/bg/project-type/Livestock_bg.jpg';
import manufacturingCoverImg from 'resources/images/bg/project-type/ManufacturingIndustries_bg.jpg';
import metalProductionCoverImg from 'resources/images/bg/project-type/MetalProduction_bg.jpg';
import miningCoverImg from 'resources/images/bg/project-type/Mining_bg.jpg';
import transportCoverImg from 'resources/images/bg/project-type/Transport_bg.jpg';
import wasteHandlingAndDisposalCoverImg from 'resources/images/bg/project-type/WasteHandlingAndDisposal_bg.jpg';

export enum CommunityStatus {
  Created = 'created',
  Edited = 'edited',
  InReview = 'in-review',
  Pending = 'pending',
  Approved = 'approved',
  Rejected = 'rejected',
}

export enum CommunityStandards {
  Verra = 'Verra',
  ClimateActionReserve = 'Climate Action Reserve',
  CDM = 'CDM',
  GoldStandard = 'Gold Standard',
  GlobalCarbonCouncil = 'Global Carbon Council',
  CarbonCapStandard = 'CarbonCap-Green Project Auditor/Independent Third Party Verifier',
}

export const communityTypeMap: { [key in CommunityTypes]: Icons } = {
  [CommunityTypes.EnergyDemand]: 'energy',
  [CommunityTypes.Forestry]: 'forestry',
  [CommunityTypes.EnergyDistribution]: 'energyDistribution',
  [CommunityTypes.EnergyIndustries]: 'energyIndustries',
  [CommunityTypes.ChemicalIndustry]: 'chemicalIndustry',
  [CommunityTypes.FugitiveEmissions]: 'fugitiveEmissions',
  [CommunityTypes.Livestock]: 'livestock',
  [CommunityTypes.ManufacturingIndustries]: 'manufacturing',
  [CommunityTypes.MetalProduction]: 'metalProduction',
  [CommunityTypes.Mining]: 'mining',
  [CommunityTypes.Transport]: 'transport',
  [CommunityTypes.WasteHandlingAndDisposal]: 'wasteHandling',
  [CommunityTypes.Afforestation]: 'Afforestation',
  [CommunityTypes.Reforestation]: 'Reforestation',
  [CommunityTypes.RenewableEnergy]: 'RenewableEnergy',
  [CommunityTypes.WasteManagement]: 'WasteManagement',
  [CommunityTypes.Agriculture]: 'Agriculture',
};

export const communityTypeBackgroundMap: { [key in CommunityTypes]: any } = {
  [CommunityTypes.EnergyDemand]: energyDemandCoverImg,
  [CommunityTypes.Forestry]: forestryCoverImg,
  [CommunityTypes.EnergyDistribution]: energyDistributionCoverImg,
  [CommunityTypes.EnergyIndustries]: energyIndustriesCoverImg,
  [CommunityTypes.ChemicalIndustry]: chemicalIndustryCoverImg,
  [CommunityTypes.FugitiveEmissions]: fugitiveEmissionsCoverImg,
  [CommunityTypes.Livestock]: livestockCoverImg,
  [CommunityTypes.ManufacturingIndustries]: manufacturingCoverImg,
  [CommunityTypes.MetalProduction]: metalProductionCoverImg,
  [CommunityTypes.Mining]: miningCoverImg,
  [CommunityTypes.Transport]: transportCoverImg,
  [CommunityTypes.WasteHandlingAndDisposal]: wasteHandlingAndDisposalCoverImg,
  [CommunityTypes.Afforestation]: forestryCoverImg,
  [CommunityTypes.Reforestation]: forestryCoverImg,
  [CommunityTypes.RenewableEnergy]: energyDistributionCoverImg,
  [CommunityTypes.WasteManagement]: wasteHandlingAndDisposalCoverImg,
  [CommunityTypes.Agriculture]: forestryCoverImg,
};
